function getColumnFromProperty(property) {
  return property && property.replace(/\./g, '-');
}

export default getColumnFromProperty;
//# sourceMappingURL=getColumnNameFromProperty.js.map
